const textFieldConfirmCreateUser = {
  name: 'Nome Completo',
  helperText: 'Insira seu nome completo',
  email: 'Email',
  password: 'Senha',
  helperTextPassword: 'Mínimo de 6 caracteres',
  confirmPassword: 'Confirme sua Senha',
  helperTextConfirmPassword: 'Senhas diferentes'
};

export default textFieldConfirmCreateUser;
